import { Routes } from '@angular/router';

import { ERoutes, UtilityRoutes } from '../../types/app-routes';
import { CardCanDeactivateGuard } from '../../services/card-can-deactivate-guard.service';

export const protocolsRoutes: Routes = [
  {
    path: ERoutes.PROTOCOLS,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./protocols-table/protocols-table.component').then(
            (m) => m.ProtocolsTableComponent
          ),
      },
      {
        path: UtilityRoutes.CARD,
        canDeactivate: [CardCanDeactivateGuard],
        loadComponent: () =>
          import('./protocol-card/protocol-card.component').then((m) => m.ProtocolCardComponent),
      },
    ],
  },
];
